<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      append-to-body
      title="谊新发货流程"
      width="1500px"
      top="10vh"
      @close="$reset('form')">
    <el-form ref="form" :model="form" :rules="ruleValidate" label-width="150px">
      <el-row>
        <el-col :span="7">
          <el-form-item label="标题" prop="title">
            <el-input v-model="form.title" :disabled="!edit"/>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item label="编号">
            <el-input v-model="form.applicationNo" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item label="申请人">
            <el-input v-model="form.creatorName" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item label="申请部门">
            <el-input v-model="form.departmentName" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item label="申请公司">
            <el-input v-model="form.customerName" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item label="申请日期">
            <el-input v-model="form.createTime" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item label="合同单位全称" prop="unitCustomerName">
            <el-input v-model="form.unitCustomerName" :disabled="!edit"/>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item label="合同编号" prop="clientContractNo">
            <el-input v-model="form.clientContractNo" :disabled="!edit"/>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item label="客户要求交货期" prop="deliveryDate">
            <el-date-picker
                v-model="form.deliveryDate"
                type="date"
                value-format="yyyy-MM-dd HH:mm:ss"
                :disabled="!edit"/>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item label="出厂日期" prop="outFactoryDate">
            <el-date-picker
                v-model="form.outFactoryDate"
                type="date"
                value-format="yyyy-MM-dd HH:mm:ss"
                :disabled="!edit"/>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item label="发货金额">
            <el-input v-model="form.shipmenAmount" :disabled="!edit"/>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item label="新老客户" prop="oldCustomer">
            <el-select v-model="form.oldCustomer" :disabled="!edit">
              <el-option label="老客户" :value="true"/>
              <el-option label="新客户" :value="false"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item label="是否冲销" prop="writeOff">
            <el-select v-model="form.writeOff" :disabled="!edit">
              <el-option label="是" :value="true"/>
              <el-option label="否" :value="false"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item label="冲销对应PC号">
            <el-input v-model="form.writeOffFactoryNos" :disabled="!edit"/>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item label="是否正式报关" prop="declareCustoms">
            <el-select v-model="form.declareCustoms" :disabled="!edit">
              <el-option label="是" :value="true"/>
              <el-option label="否" :value="false"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item label="报关金额">
            <el-input v-model="form.declareCustomsAmount" :disabled="!edit"/>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item label="付款方式" prop="payment">
            <el-input v-model="form.payment" :disabled="!edit"/>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item label="合同约定运输方式" prop="contractShipmentType">
            <el-select v-model="form.contractShipmentType" :disabled="!edit">
              <el-option label="空运-自提" :value="'空运-自提'"/>
              <el-option label="空运-门到门" :value="'空运-门到门'"/>
              <el-option label="汽运-自提" :value="'汽运-自提'"/>
              <el-option label="汽运-门到门" :value="'汽运-门到门'"/>
              <el-option label="DHL" :value="'DHL'"/>
              <el-option label="海运-上海港口" :value="'海运-上海港口'"/>
              <el-option label="海运-对方国家港口" :value="'海运-对方国家港口'"/>
              <el-option label="海运-对方国家港口" :value="'海运-对方国家港口'"/>
              <el-option label="国内快递" :value="'国内快递'"/>
              <el-option label="铁运" :value="'铁运'"/>
              <el-option label="其他" :value="'其他'"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item label="DHL费用承担方">
            <el-select v-model="form.dHLShipmentBelong" :disabled="!edit">
              <el-option label="我方承担费用" :value="'我方承担费用'"/>
              <el-option label="客户承担费用" :value="'客户承担费用'"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item label="包装要求" prop="packRequirement">
            <el-select v-model="form.packRequirement" :disabled="!edit">
              <el-option label="大包装" :value="'大包装'"/>
              <el-option label="小包装" :value="'小包装'"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item label="品类">
            <el-select v-model="form.category" :disabled="!edit">
              <el-option label="文件" :value="'文件'"/>
              <el-option label="正常销售" :value="'正常销售'"/>
              <el-option label="售后(我方承担费用)" :value="'售后(我方承担费用)'"/>
              <el-option label="售后(客户承担费用)" :value="'售后(客户承担费用)'"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item label="评审交期" prop="reviewDeadline">
            <el-date-picker
                v-model="form.reviewDeadline"
                type="date"
                value-format="yyyy-MM-dd HH:mm:ss"
                :disabled="!edit"/>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item label="供货公司" prop="supplyCompanyList">
            <el-checkbox-group v-model="form.supplyCompanyList" :disabled="!edit" @change="supplyCompanySelect">
              <el-checkbox label="电气"/>
              <el-checkbox label="外购"/>
            </el-checkbox-group>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item label="订仓日期">
            <el-date-picker
                v-model="form.bookingDate"
                type="date"
                value-format="yyyy-MM-dd HH:mm:ss"
                :disabled="!edit"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="7">
          <el-form-item label="实际收款情况">
            <el-input v-model="form.actualCharges" :disabled="!edit"/>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item label="进仓地址">
            <el-input v-model="form.warehouseAddress" :disabled="!edit"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="7">
          <el-form-item label="售后清单">
            <el-input v-model="form.afterSalesList" type="textarea" :disabled="!edit" autosize/>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item label="售后件数">
            <el-input v-model="form.afterSalesQty" type="number" :disabled="!edit"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="7">
          <el-form-item label="外采清单">
            <el-input v-model="form.buyList" type="textarea" :disabled="!edit" autosize/>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item label="外采件数">
            <el-input v-model="form.buyQty" type="number" :disabled="!edit"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="22">
          <el-form-item label="出厂编号">
            <el-input v-model="form.factoryNos" type="textarea" disabled autosize/>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div
        style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">
      相关附件
    </div>
    <div>
      <el-upload
          action=""
          multiple
          :http-request="submitUpload"
          :show-file-list="false"
          :disabled="uploadLoading"
          style="display: inline-block; float: left; margin: 5px;">
        <el-button type="primary" plain>
          <i class="el-icon-upload el-icon--right"/>
          附件上传
        </el-button>
      </el-upload>
    </div>
    <el-table
        v-if="form.accessoryList"
        ref="payData1"
        :data="form.accessoryList">
      <el-table-column type="index" align="center" label="行号"/>
      <el-table-column prop="fileName" align="center" label="附件描述"/>
      <el-table-column label="操作" align="center" width="120" class-name="vm-table_operate">
        <template slot-scope="scope">
          <el-button type="primary" @click="oneDelete(scope.$index)">删除</el-button>
          <el-button type="primary" @click="download(scope.row)">下载</el-button>
        </template>
      </el-table-column>
    </el-table>
    <span v-if="edit" slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" :loading="submitLoading" @click="saveHandle">保存</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import loginUtil from "@/util/loginUtil";
  import moment from "moment";

  export default {
    name: "YiXinApplicationEdit",
    components: {},
    data() {
      return {
        pkid: "",
        dialogVisible: false,
        submitLoading: false,
        uploadLoading: false,
        edit: 0,
        editCompleteAuth: this.$auth(630),
        form: {
          unitCustomerName: "",
          packRequirement: "",
          woolenBody: "",
          payment: "",
          title: "",
          departmentId: 0,
          deliveryDate: "",
          supplyCompany: "",
          contractShipmentType: "",
          applicationNo: "",
          customerId: 0,
          oldCustomer: true,
          bookingDate: "",
          declareCustoms: true,
          category: "",
          declareCustomsAmount: 0,
          outFactoryDate: "",
          warehouseAddress: "",
          factoryNos: "",
          writeOff: true,
          dHLShipmentBelong: "",
          clientContractNo: "",
          writeOffFactoryNos: "",
          reviewDeadline: "",
          createTime: "",
          shipmenAmount: 0,
          actualCharges: 0,
          departmentName: "",
          customerName: "",
          creatorName: "",
          accessoryList: [],
          creatorId: 0,
          supplyCompanyList: [],
          detailList: [],
          afterSalesList: "",
          afterSalesQty: 0,
          buyList: "",
          buyQty: 0,
        },

        ruleValidate: {
          title: {required: true, message: "标题不能为空", trigger: "blur"},
          unitCustomerName: {required: true, message: "合同单位全称不能为空", trigger: "blur"},
          clientContractNo: {required: true, message: "合同编号不能为空", trigger: "blur"},
          deliveryDate: {required: true, message: "客户要求交货期不能为空", trigger: "blur"},
          outFactoryDate: {required: true, message: "出厂日期不能为空", trigger: "blur"},
          oldCustomer: {required: true, message: "新老客户不能为空", trigger: "blur"},
          writeOff: {required: true, message: "是否冲销不能为空", trigger: "blur"},
          declareCustoms: {required: true, message: "是否正式报关不能为空", trigger: "blur"},
          payment: {required: true, message: "付款方式不能为空", trigger: "blur"},
          contractShipmentType: {required: true, message: "合同约定运输方式不能为空", trigger: "blur"},
          packRequirement: {required: true, message: "包装要求不能为空", trigger: "blur"},
          reviewDeadline: {required: true, message: "评审交期不能为空", trigger: "blur"},
          supplyCompanyList: {required: true, message: "供货公司不能为空", trigger: "blur"},
        },
      };
    },
    methods: {
      open(pkid, edit, selection) {
        this.dialogVisible = true;
        this.pkid = pkid;
        this.edit = edit;
        if (pkid) {
          this.getData();
        } else {
          let factoryNos = "";
          let amount = 0;
          let detailList = [];
          selection.forEach((item) => {
            factoryNos += item.salesOrderNO + ",";
            amount += item.totalMoney;
            this.form.customerId = item.customerID;
            this.form.customerName = item.invoiceName;
            let detail = {
              techParamBillId: item.pkid,
              techParamBillNo: item.salesOrderNO,
            };
            detailList.push(detail);
          });
          let userinfo = loginUtil.getUserInfo();
          console.log(userinfo);
          this.form.creatorName = userinfo.name;
          this.form.creatorId = userinfo.userId;
          this.form.departmentName = userinfo.departmentName;
          this.form.factoryNos = factoryNos;
          this.form.shipmenAmount = amount.toFixed(2);
          this.form.detailList = detailList;

          console.log(this.form);
        }

      },


      //编辑查详情
      getData() {
        this.$http.get("basic", "YiXinShipmentApplication/" + this.pkid).then((resp) => {
          this.form = resp;
        });
      },

      //新建
      getNewData() {
      },


      oneDelete(index) {
        this.form.accessoryList.splice(index, 1);
      },

      download(row) {
        let data = {
          name: row.fileName,
          uuid: row.filePath,
        };
        this.$http.exportFile("basic", "file/download", data).then(res => {
          console.log(res);
          let blob = new Blob([res.data], {type: "application"});
          let fileName = decodeURI(res.config.params.name);
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            let a = document.createElement("a");
            a.href = URL.createObjectURL(blob);
            a.download = fileName;
            a.style.display = "none";
            document.body.appendChild(a);
            a.click();
            URL.revokeObjectURL(a.href);
            document.body.removeChild(a);
          }
        });
      },


      // 保存
      saveHandle() {
        this.submitLoading = true;

        this.$refs.form.validate((valid) => {
          if (valid) {
            if (!this.pkid) {
              this.$http
                .post("basic", "YiXinShipmentApplication", this.form)
                .then(() => {
                  this.submitLoading = false;
                  this.dialogVisible = false;
                  this.$emit("save-success");
                  this.$message.success("保存成功");
                })
                .catch(() => {
                  this.submitLoading = false;
                });
            } else {
              this.$http
                .put("basic", "YiXinShipmentApplication", this.form)
                .then(() => {
                  this.submitLoading = false;
                  this.dialogVisible = false;
                  this.$emit("save-success");
                  this.$message.success("编辑成功");
                })
                .catch(() => {
                  this.submitLoading = false;
                });
            }
          } else {
            this.submitLoading = false;
          }
        });


      },


      submitUpload(params) {
        this.uploadLoading = true;
        let formData = new FormData(); //  用FormData存放上传文件
        formData.append("file", params.file);
        formData.append("Authorization", loginUtil.getToken());
        this.$http
          .post("basic", "file/upload", formData)
          .then((res) => {
            this.uploadLoading = false;
            console.log(res);
            this.form.accessoryList.push({
              fileName: res.originalName,
              filePath: res.fullPath,
              note: "",
            });
            this.$message.success("上传成功");
          })
          .catch(() => {
            this.uploadLoading = false;
            this.$message.error("上传失败");
          });
      },

      supplyCompanySelect() {
        this.form.supplyCompany = this.form.supplyCompanyList.length > 0 ? this.form.supplyCompanyList.join(",") : "";
      },
    },
  };
</script>